import { createSelector } from 'reselect';
import { normalize, schema } from 'normalizr';

export const branchSchema = new schema.Entity('branchSchema');
export const branchesSchema = [branchSchema];

export const getBranchesReducer = state => state.branches;

export const selectBranches = createSelector(
  [getBranchesReducer],
  ({ branches }) => branches,
);

export const selectBranchesLoading = createSelector(
  [getBranchesReducer],
  ({ pending }) => pending,
);

export const selectBranchesError = createSelector(
  [getBranchesReducer],
  ({ error }) => error,
);

export const selectBranchOptionsList = createSelector(
  [getBranchesReducer],
  ({ branches = [] }) => {
    return branches.map(({ id, name }) => ({
      value: id,
      label: name,
    }));
  },
);

export const selectBranchesDictionary = createSelector(
  [getBranchesReducer],
  ({ branches }) => {
    const { entities } = normalize(branches, branchesSchema);
    return entities?.branchSchema || {};
  },
);
